import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
// Limitless imports
import { TranslationProvider } from "@limitless/common/hooks/translation/TranslationContext";
import { useResources } from "@limitless/common/hooks/platform-resource/PlatformResourceContext";
import { useAppConfig } from "@limitless/common/hooks/app-config/AppConfigContext";
import { createTheme } from "../../theme/Theme";
import LoadingScreen from "../../screens/LoadingScreen";
import { useSignInContext } from "../../../expert";
import { cacheUILabels } from "../../apis/MessageResourceActions";
const PortalApp = ({
  children,
  themeOverrides
}) => {
  const [isAccessTokenLoading, setIsAccessTokenLoading] = React.useState(true);
  const {
    checkUserAccessTokens
  } = useSignInContext();
  React.useEffect(() => {
    checkUserAccessTokens(() => setIsAccessTokenLoading(false));
  }, []);
  const {
    resources: {
      uilabels,
      theme,
      loading: isResourcesLoading
    }
  } = useResources();
  React.useEffect(() => {
    if (!isResourcesLoading && uilabels && Object.keys(uilabels).length) {
      cacheUILabels(uilabels);
    }
  }, [isResourcesLoading]);
  const {
    config: {
      loading: isConfigLoading
    }
  } = useAppConfig();
  const remoteTheme = React.useMemo(() => {
    return createTheme(theme, themeOverrides);
  }, [theme, themeOverrides]);

  //if all these are finished, we're done loading, hurray
  const loading = isResourcesLoading || isConfigLoading || isAccessTokenLoading;
  return /*#__PURE__*/React.createElement(StyledEngineProvider, {
    injectFirst: true
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: remoteTheme
  }, /*#__PURE__*/React.createElement(TranslationProvider, {
    resourceBundle: uilabels
  }, loading ? /*#__PURE__*/React.createElement(LoadingScreen, null) : children)));
};
export default PortalApp;
PortalApp.propTypes = {
  children: PropTypes.node.isRequired,
  themeOverrides: PropTypes.object
};